import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';
import Amen from './Amen';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    textAlign: 'center',
    fontSize: '1.3rem',
    margin: 'auto',
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    border: '1px solid #ece7e7',
    width: '30%',
    margin: 'auto',
    opisZrna: {
      width: '60%',
      marginLeft: '20%',
      boxShadow: '0 1.5rem 1rem rgba(0, 0, 0, 0.2)',
    },
    opisMolitve: {
      fontSize: '2rem',
      color: '#093145',
      lineHeight: '1.3',
    },
  },
  nivo: {
    position: 'relative',
    zIndex: '5',
    margin: '0',
  },
}));

function ApostolskoVjerovanje() {
  const classes = useStyles();
  const { aktivnaZemlja, trenutnaKrunica } = storeKrunica;
  const {
    uImeOcaSina,
    isuse,
    apostolskoUvod,
    apostolskoVjerovanje,
    apostolskoVjerovanjeText,
    krunice,
  } = aktivnaZemlja;

  return (
    <React.Fragment>
      <div className={classes.opisMolitve}>
        <div>
          <strong>{uImeOcaSina}</strong>
          <Amen />
        </div>
        {trenutnaKrunica !== 'gertruda' && (
          <div style={{ marginTop: 10 }}>
            O, <strong>{isuse} </strong>
            {apostolskoUvod}
          </div>
        )}
        {trenutnaKrunica === 'rita' && (
          <div style={{ marginTop: 3, marginBottom: 3 }}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.bozePriteciUpomoc
            }
          </div>
        )}
        {trenutnaKrunica === 'rita' && (
          <div style={{ marginTop: 3, marginBottom: 3 }}>
            {
              krunice.find((k) => k.value === trenutnaKrunica)
                ?.gospodinePohitPomognes
            }
          </div>
        )}
        <div>
          <strong>{apostolskoVjerovanje}</strong>
        </div>
        {apostolskoVjerovanjeText}
        <div>
          <Amen />
        </div>
      </div>
    </React.Fragment>
  );
}

export default observer(ApostolskoVjerovanje);
